// extracted by mini-css-extract-plugin
export default {"checkBoxContainer":"_1rgfe6Wi","checkBoxIcon":"_2WR-O5AZ","checkBoxLabel":"_3-Xt0uM5","labelIcon":"_2DMtlxQl","flexContainer":"WXOiTg4S"};